import _ from 'lodash';
import uuidv4 from 'uuid/v4';
const LOCAL_STORAGE_TRANSFER_KEY = 'doctor-transfer-notify-keys';
export default class PatientTransferKeys {
    constructor() {
        this.transferNotifyKeys = PatientTransferKeys.getTransferNotifyKeys();
    }
    static generateKey() {
        return uuidv4();
    }
    static getTransferNotifyKeys() {
        const lsValue = localStorage.getItem(LOCAL_STORAGE_TRANSFER_KEY);
        if (!lsValue) {
            return [];
        }
        let options;
        try {
            options = JSON.parse(lsValue);
        }
        catch (e) {
            return [];
        }
        if (!_.isArray(options)) {
            return [];
        }
        return options;
    }
    static clearTransferLocalStorage() {
        localStorage.removeItem(LOCAL_STORAGE_TRANSFER_KEY);
    }
    addTransferNotifyKey(key) {
        this.transferNotifyKeys.push(key);
        localStorage.setItem(LOCAL_STORAGE_TRANSFER_KEY, JSON.stringify(this.transferNotifyKeys));
    }
    isKeyPresent(key) {
        return this.transferNotifyKeys.includes(key);
    }
    removeKey(key) {
        const index = this.transferNotifyKeys.indexOf(key);
        if (index !== -1) {
            this.transferNotifyKeys.splice(index, 1);
        }
        localStorage.setItem(LOCAL_STORAGE_TRANSFER_KEY, JSON.stringify(this.transferNotifyKeys));
    }
}
